module.exports = "/_next/static/images/apple-monotone-00d63b8b57d364ee160e8edab73f0ed4.svg";